import React, {useContext} from 'react'
import LinkCell3 from '../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3'
import ModalsStore from '../../components/Pages/Modals.store'
import { useAPI } from '../../hooks/useAPI'
import moment from 'moment'
import {AuthContext} from "../../context/AuthContext";

const EditPatientCell = ({ label, patientId, API, closeCallback, resultId }) => {
  const { getPatient, updatePatient } = API
  const { APIRequest } = useAPI()
  const {token} = useContext(AuthContext)
  return (
    <LinkCell3 linkTitle={label} linkRoute={''} editClick={async () => {
      ModalsStore.showModal('EditPatient2',
        {
          initialForm: await APIRequest(getPatient(token.userId,patientId, resultId))
            .then(response => {
              if (response.body) {
                return {
                  ...response.body?.data,
                  dob: moment(response.body?.data.dob).format('YYYY-MM-DD'),
                }
              }
            })
        },
        {
          closeHandler() {
            closeCallback()
          },
          submit(formData) {

            return APIRequest(updatePatient(token.userId,patientId, resultId), {
              ...formData, dob: moment(formData.dob).format('YYYY-MM-DD')
            })
              .then(response => response.status === 200 ? 'success' : 'error')
          }
        })

    }} />
  )
}

export default EditPatientCell
